<template>
  <h3>Your password was updated successfully!</h3>
  <p>Please wait while we log you in with your new password. Or <a @click="loginSubmitted" href="#">click here</a> to do it now.</p>
</template>

<script setup lang="ts">
import { Ref, ref } from 'vue'

const activateLoginRedirect: Ref<boolean> = ref(true)
const emit = defineEmits(['loginSubmitted', 'errorCatched'])

const loginSubmitted = () => {
  window.localStorage.removeItem('email')
  window.localStorage.removeItem('provider')
  activateLoginRedirect.value = false
  emit('loginSubmitted')
}

window.setTimeout(function () {
  if (activateLoginRedirect.value) {
    loginSubmitted()
  }
}, 5000)
</script>
